import { useCallback, useState } from "react";

import type { PanelState } from "./types";

export const usePanelFetch = <T>(fetcher: () => Promise<T[]>) => {
  const [state, setState] = useState<PanelState<T>>({
    loading: false,
    error: null,
    results: null,
    fetchedAt: null,
  });

  const run = useCallback(async () => {
    setState((s) => ({ ...s, loading: true, error: null }));
    try {
      const results = await fetcher();
      setState({ loading: false, error: null, results, fetchedAt: new Date() });
    } catch (e) {
      setState({ loading: false, error: (e as Error).message, results: null, fetchedAt: null });
    }
  }, [fetcher]);

  return { state, run };
};
